@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Dane przydomowej oczyszczalni ścieków
    </h3>
    <p class="mb-2">
      <strong>Dane adresowe</strong>
    </p>
    <div class="row mb-2">
      <div class="col-12">
        <app-label label="Miejscowość:">
          {{ application?.city || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Ulica:">
          {{ application?.street || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Numer porządkowy:">
          {{ application?.houseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <p class="mb-2">
      <strong>Dane oczyszczalni</strong>
    </p>
    <div class="row">
      <div class="col-12">
        <app-label label="Typ oczyszczalni:">
          {{ application?.treatmentPlantType || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Data uruchomienia oczyszczalni:">
          {{ application?.treatmentPlantCommissioningDate | date }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Przepustowość oczyszczalni:">
          {{ application?.treatmentPlantCapacity | toNumber | number }} (m<sup>3</sup>)
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
